import type { FunctionComponent } from "react";
import { useCallback } from "react";
import { noop } from "rxjs";
import { Text } from "@smartsuite/react-ui/lib";

import { StyledOperation, StyledIcon, StyledLine } from "./styles";
import { OperatorDescriptionKinds } from "../../constanst";

export type MathOptions =
  | OperatorDescriptionKinds.MATH_ADD
  | OperatorDescriptionKinds.MATH_SUBTRACT
  | OperatorDescriptionKinds.MATH_DIVIDE
  | OperatorDescriptionKinds.MATH_MULTIPLY;

interface MathOptionProps {
  type: MathOptions;
  isPlaceholder?: boolean;

  onClick?: (type: MathOptions) => void;
}

export const MathOption: FunctionComponent<MathOptionProps> = ({
  type,
  isPlaceholder = false,
  onClick = noop,
}) => {
  const handleClick = useCallback(() => {
    onClick(type);
  }, [type]);
  const text = textList[type];

  return (
    <StyledOperation isPlaceholder={isPlaceholder} onClick={handleClick}>
      <StyledIcon type={type}>
        {type === OperatorDescriptionKinds.MATH_DIVIDE && <StyledLine />}
      </StyledIcon>
      <Text weight="medium" color="tertiary">
        {text}
      </Text>
    </StyledOperation>
  );
};

// TODO: Add translates
const textList = {
  [OperatorDescriptionKinds.MATH_ADD]: "Add",
  [OperatorDescriptionKinds.MATH_SUBTRACT]: "Subtract",
  [OperatorDescriptionKinds.MATH_DIVIDE]: "Divide",
  [OperatorDescriptionKinds.MATH_MULTIPLY]: "Multiply",
};
